import { useState, useEffect } from 'react';
import { api } from '../services/apiService';
import PopupList from '../components/PopupList';

const Popups = () => {
  const [popups, setPopups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchPopups = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/popups');
      console.log('API Response:', response.data);
      setPopups(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Fetch error:', err);
      setError(err.response?.data?.error || 'Failed to fetch popups');
      setPopups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPopups();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading popups...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Popup Management</h2>
      <PopupList popups={popups} fetchPopups={fetchPopups} />
    </div>
  );
};

export default Popups;